import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './icons/GreenCheck-Icon.svg'


_pushScopeId("data-v-82a8d51a")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "includes-text" }, "What's included?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  opacity: "0.5",
  cx: "9",
  cy: "9",
  r: "9",
  fill: "#C4C4C4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 8L9 11L6 8",
  stroke: "#6C6C6C",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "mt-3 row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "pe-2",
  height: "11",
  src: _imports_0,
  alt: "✓"
}, null, -1)
const _hoisted_7 = { class: "\n          d-flex\n          align-items-center\n          justify-content-between\n          ps-1\n          price-container\n        " }
const _hoisted_8 = {
  key: 0,
  class: "cera-med nowrap mb-0"
}
const _hoisted_9 = { class: "fs-6 fw-600" }
const _hoisted_10 = { class: "fs-6 fw-600" }
const _hoisted_11 = {
  key: 1,
  class: "cera-med nowrap mb-0"
}
const _hoisted_12 = { class: "fs-6 fw-600" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mx-2" }, "per month", -1)
const _hoisted_14 = { class: "d-flex align-items-center pe-1 deductible" }
const _hoisted_15 = { class: "pe-1" }
const _hoisted_16 = { class: "fs-8" }
const _hoisted_17 = { class: "fs-8" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "deductibles", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleInclude && _ctx.toggleInclude(...args))),
      class: _normalizeClass(["\n      d-flex\n      includes-container\n      mt-2\n      py-2\n      pe-2\n      ps-4\n      justify-content-between\n      align-items-center\n    ", {
      'includes-container-open': _ctx.wereProductAddedToCard || _ctx.includeOpen || _ctx.open,
      pointer: !_ctx.open,
    }])
    }, [
      _hoisted_1,
      (!_ctx.open && !_ctx.wereProductAddedToCard)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            class: _normalizeClass(["chevron", { 'chevron-rotate': _ctx.includeOpen }]),
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_4, 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([{
      'plan-details-container-transition':
        _ctx.wereProductAddedToCard || _ctx.includeOpen || _ctx.open,
      'z-9': _ctx.wereProductAddedToCard || _ctx.includeOpen || _ctx.open,
    }, "\n      d-flex\n      flex-column\n      align-items-flex-start\n      justify-content-flex-start\n      plan-details-container\n      px-4\n    "])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["plan-details-container-text inter", {
        'plan-details-container-text-transition':
          _ctx.wereProductAddedToCard || _ctx.includeOpen || _ctx.open,
      }])
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.marketingProperties.included.description), 1),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marketingProperties.included.details, (detail) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-1 col-12 col-xl-6",
              key: detail
            }, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(detail), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("hr", {
          class: _normalizeClass(["line", {
          'line-transition': _ctx.wereProductAddedToCard || _ctx.includeOpen || _ctx.open,
        }])
        }, null, 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["\n        d-flex\n        flex-row\n        plan-details-container-text\n        justify-content-between\n        mb-3\n      ", {
        'plan-details-container-text-transition':
          _ctx.wereProductAddedToCard || _ctx.includeOpen || _ctx.open,
      }])
      }, [
        _createElementVNode("div", _hoisted_7, [
          (
            _ctx.productPriceRange.min !== _ctx.productPriceRange.max && !_ctx.hidePriceRange
          )
            ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [
                _createTextVNode(" $" + _toDisplayString(_ctx.formattedNumberIntegerPart(_ctx.productPriceRange.min)), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formattedNumberDecimalPart(_ctx.productPriceRange.min)), 1),
                _createTextVNode(" - $" + _toDisplayString(_ctx.formattedNumberIntegerPart(_ctx.productPriceRange.max)), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedNumberDecimalPart(_ctx.productPriceRange.max)), 1)
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.productPriceRange.min === _ctx.productPriceRange.max || _ctx.hidePriceRange
          )
            ? (_openBlock(), _createElementBlock("h2", _hoisted_11, [
                _createTextVNode(" $" + _toDisplayString(_ctx.formattedNumberIntegerPart(_ctx.productPriceRange.max)), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formattedNumberDecimalPart(_ctx.productPriceRange.max)), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(" $" + _toDisplayString(_ctx.formattedNumberIntegerPart(_ctx.deductiblePriceRange.min)), 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formattedNumberDecimalPart(_ctx.deductiblePriceRange.min)), 1),
            _createTextVNode(" - $" + _toDisplayString(_ctx.formattedNumberIntegerPart(_ctx.deductiblePriceRange.max)), 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formattedNumberDecimalPart(_ctx.deductiblePriceRange.max)), 1)
          ]),
          _hoisted_18
        ])
      ], 2)
    ], 2)
  ], 64))
}